<template>
  <div
    id="kt_header_mobile"
    class="header-mobile align-items-center"
    v-bind:class="headerClasses"
  >
    <!--begin::Logo-->
    <a href="/">
      <img alt="Logo" :src="headerLogo" height="40" />
    </a>
    <!--end::Logo-->
    <!--begin::Toolbar-->
    <div class="d-flex align-items-center">
      <!--begin::Aside Mobile Toggle-->
      <button
        v-if="asideEnabled"
        class="btn p-0 burger-icon burger-icon-left"
        id="kt_aside_mobile_toggle"
      >
        <span></span>
      </button>
      <!--end::Aside Mobile Toggle-->
      <!--begin::Header Menu Mobile Toggle-->
      <!-- <button
        class="btn p-0 burger-icon ml-4"
        id="kt_header_mobile_toggle"
        ref="kt_header_mobile_toggle"
      >
        <span></span>
      </button> -->
      <!--end::Header Menu Mobile Toggle-->
      <!--begin::Topbar Mobile Toggle-->
      <button
        class="btn btn-hover-text-primary p-0 ml-2"
        id="kt_header_mobile_topbar_toggle"
        ref="kt_header_mobile_topbar_toggle"
      >
        <span class="svg-icon svg-icon-xl">
          <!--begin::Svg Icon | path:svg/icons/General/User.svg-->
          <inline-svg
            class="svg-icon"
            src="/media/svg/icons/General/User.svg"
          />
          <!--end::Svg Icon-->
        </span>
      </button>
      <!--end::Topbar Mobile Toggle-->
    </div>
    <!--end::Toolbar-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import KTLayoutHeaderTopbar from "@/assets/js/layout/base/header-topbar.js";

export default {
  name: "KTHeaderMobile",
  components: {},
  mounted() {
    // Init Header Topbar For Mobile Mode
    KTLayoutHeaderTopbar.init(this.$refs["kt_header_mobile_topbar_toggle"]);
  },
  computed: {
    ...mapGetters(["layoutConfig", "getClasses"]),

    /**
     * Get header logo
     * @returns {string}
     */
    headerLogo() {
      return "/images/logo-medhop-transparent.png";
    },

    /**
     * Get classes for mobile header
     * @returns {null|*}
     */
    headerClasses() {
      const classes = this.getClasses("header_mobile");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    },

    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
  },
};
</script>

<style lang="scss" scoped>
.header-mobile {
  position: relative;
  isolation: isolate;
  background:
    radial-gradient(circle at 20% -70%, rgba(115, 235, 222, 0.3) 0 46px, transparent 47px),
    radial-gradient(circle at 88% 155%, rgba(255, 255, 255, 0.16) 0 42px, transparent 43px),
    linear-gradient(112deg, #102c59 0%, #145b88 50%, #1e958f 100%) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2) !important;
  box-shadow: 0 8px 22px rgba(14, 47, 85, 0.18) !important;

  > * {
    position: relative;
    z-index: 1;
  }

  > a {
    display: inline-flex;
    align-items: center;
    padding: 4px 9px;
    border: 1px solid rgba(255, 255, 255, 0.34);
    border-radius: 11px;
    background: rgba(255, 255, 255, 0.92);
    box-shadow: 0 4px 12px rgba(5, 38, 67, 0.12);
  }
}

#kt_aside_mobile_toggle,
#kt_header_mobile_topbar_toggle {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.09) !important;
  border: 1px solid rgba(255, 255, 255, 0.14) !important;
  transition: background-color 0.2s ease, border-color 0.2s ease,
    transform 0.2s ease;

  &:hover,
  &:focus {
    background: rgba(255, 255, 255, 0.2) !important;
    border-color: rgba(255, 255, 255, 0.34) !important;
    transform: translateY(-1px);
  }
}

:deep(.burger-icon > span),
:deep(.burger-icon > span::before),
:deep(.burger-icon > span::after) {
  background-color: #ffffff !important;
}

:deep(.svg-icon svg g [fill]),
:deep(.svg-icon svg path[fill]) {
  fill: #ffffff !important;
}
</style>
